import styled from 'styled-components';
import { Vehicle } from '../../../../types/vehicle';
import { formatCurrency } from '../../../../utils';

type Props = {
  vehicle: Vehicle;
};

const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  color: #000;
  font-weight: 500;
`;

const formatLane = (label: string, value: number | null) => {
  if (!value) return `${label} -`;
  return `${label} - ${formatCurrency(value)}`;
};

export const OtherOffers = ({ vehicle }: Props) => {
  return (
    <Wrapper>
      <span>{formatLane('OL', vehicle.other_offers?.open_lane)}</span>
      <span>{formatLane('ACV', vehicle.other_offers?.acv)}</span>
      <span>{formatLane('O/r', vehicle.other_offers?.other)}</span>
    </Wrapper>
  );
};
